// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verse-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.verse-content-ltr {\n  flex: 1;\n  direction: ltr;\n  padding: 0px 0px 15px;\n}\n\n.verse-content-rtl {\n  flex: 1;\n  direction: rtl;\n  padding: 0px 0px 15px;\n}\n\n.placeholder-text {\n  font-style: italic;\n}\n", ""]);
// Exports
module.exports = exports;
